// import React, { useRef, useState, useEffect } from "react";
// import Image from "next/image";
// import { motion, useScroll, useTransform, useInView } from "framer-motion";
// import { Card, CardContent } from "../../../../components/ui/card";
// import {
//   Avatar,
//   AvatarFallback,
//   AvatarImage,
// } from "../../../../components/ui/avatar";

// const TestimonialCard = ({ children, className, delay, scrollY }) => {
//   const cardRef = useRef(null);
//   const isInView = useInView(cardRef, { once: true, threshold: 0.1 });

//   return (
//     <motion.div
//       ref={cardRef}
//       className={className}
//       initial={{ opacity: 0, scale: 0.8, y: 50 }}
//       animate={isInView ? { opacity: 1, scale: 1, y: 0 } : {}}
//       transition={{ duration: 0.6, delay: delay, ease: "easeOut" }}
//       whileHover={{
//         scale: 1.05,
//         boxShadow: "0px 1px 2px rgba(255, 174, 0, 0.9)",
//       }}
//       style={{ y: scrollY }}
//     >
//       <Card className="w-full h-full bg-inherit rounded-inherit border-none">
//         {children}
//       </Card>
//     </motion.div>
//   );
// };

// const MobileTestimonialCard = ({ children, isActive }) => {
//   const cardRef = useRef(null);
//   const isInView = useInView(cardRef, { once: true, threshold: 0.1 });

//   return (
//     <motion.div
//       ref={cardRef}
//       className={`absolute w-full ${
//         isActive ? "opacity-100" : "opacity-0 pointer-events-none"
//       }`}
//       initial={{ x: 100, opacity: 0 }}
//       animate={
//         isInView && isActive ? { x: 0, opacity: 1 } : { x: 100, opacity: 0 }
//       }
//       transition={{ duration: 0.6, ease: "easeOut" }}
//     >
//       {children}
//     </motion.div>
//   );
// };

// const TestimonialsSection = () => {
//   const sectionRef = useRef(null);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start end", "end start"],
//   });

//   const y1 = useTransform(scrollYProgress, [0, 1], [0, -50]);
//   const y2 = useTransform(scrollYProgress, [0, 1], [0, -100]);
//   const y3 = useTransform(scrollYProgress, [0, 1], [0, -30]);

//   const testimonials = [
//     {
//       id: 1,
//       avatarSrc:
//         "https://images.unsplash.com/photo-1730458001024-df18936795d2?q=80&w=735&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//       name: "Ravi",
//       company: "Startup Founder",
//       text: "The idea of blending mentorship with travel is long overdue — I immediately signed up for the first entrepreneur retreat. Even though it got postponed, I’m still in and rooting for what this team is building.",
//       ratingSrc: "/rating.svg",
//     },
//     {
//       id: 2,
//       avatarSrc: "/ellipse-199.svg",
//       name: "Ishita",
//       company: "Community Builder & Creator",
//       text: "I’ve seen many travel startups come and go. This one hits different. It’s not about ticking places, but unlocking something within you. I can’t wait to be part of it when it launches fully.",
//       ratingSrc: "/rating.svg",
//     },
//     {
//       id: 3,
//       avatarSrc:
//         "https://images.unsplash.com/photo-1642683392929-ee53abaac74c?q=80&w=1208&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//       name: "Kunal",
//       company: "Creator Mentor (Planned Trip)",
//       text: "I was invited to co-host a content creators’ trip. The structure, intent, and clarity behind Outcome Outing made me say yes immediately. This isn’t a vacation — it’s a transformational experience.",
//       extraAvatar: "/ellipse-201.svg",
//     },
//     {
//       id: 4,
//       avatarSrc:
//         "https://images.unsplash.com/photo-1569757543069-8ef616574b16?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//       name: "Sneha",
//       company: "B-School Student",
//       text: "Honestly, just being added to the Outcome Outing WhatsApp group gave me more clarity than most webinars do. The kind of people this community is attracting already says a lot.",
//       quoteSrc: "/group-6.png",
//     },
//     {
//       id: 5,
//       avatarSrc:
//         "https://images.unsplash.com/photo-1642498588059-af2806955839?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//       name: "Sameer, D2C Entrepreneur",
//       company: "Outcome Outing Advisor",
//       text: "What stood out for me was the way they curated activities for actual outcomes. I saw the itinerary for their Goa founder trip, and it looked more aligned than most startup events.",
//     },
//     {
//       id: 6,
//       avatarSrc:
//         "https://images.unsplash.com/photo-1681164315430-6159b2361615?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//       name: "Deep",
//       company: "Early Community Member & Tech Consultant",
//       text: "When they shared the idea of learning while traveling, I felt seen. I don’t vibe with textbook coaching — this felt like the growth journey I’ve been craving.",
//       ratingSrc: "/rating.svg",
//     },
//   ];

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentIndex((prev) =>
//         prev === testimonials.length - 1 ? 0 : prev + 1
//       );
//     }, 5000);
//     return () => clearInterval(timer);
//   }, [testimonials.length]);

//   const handlePrev = () => {
//     setCurrentIndex((prev) =>
//       prev === 0 ? testimonials.length - 1 : prev - 1
//     );
//   };

//   const handleNext = () => {
//     setCurrentIndex((prev) =>
//       prev === testimonials.length - 1 ? 0 : prev + 1
//     );
//   };

//   return (
//     <motion.section
//       ref={sectionRef}
//       className="relative w-full h-[100vh] py-6 sm:py-8 lg:py-16 overflow-hidden bg-[#0D0D0D]"
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 1 }}
//     >
//       {/* Desktop Layout (1024px and above) */}
//       <div className="relative w-full mx-auto hidden lg:block">
//         <motion.div className="relative" style={{ y: y3 }}>
//           <Image
//             className="w-full"
//             alt="Vector background"
//             src="/vector-19.svg"
//             width={1920}
//             height={1080}
//           />
//           <motion.div
//             className="absolute w-[11px] h-[11px] top-9 right-24 bg-white rounded-[5.5px] border border-solid"
//             animate={{ scale: [1, 1.2, 1], opacity: [0.7, 1, 0.7] }}
//             transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
//           />
//           <motion.div
//             className="absolute w-[11px] h-[11px] top-[100px] left-[322px] bg-white rounded-[5.5px] border border-solid"
//             animate={{ scale: [1, 1.2, 1], opacity: [0.7, 1, 0.7] }}
//             transition={{
//               duration: 2,
//               repeat: Infinity,
//               ease: "easeInOut",
//               delay: 0.5,
//             }}
//           />
//           <motion.div
//             className="absolute w-[11px] h-[11px] bottom-2 left-[35px] bg-white rounded-[5.5px] border border-solid"
//             animate={{ scale: [1, 1.2, 1], opacity: [0.7, 1, 0.7] }}
//             transition={{
//               duration: 2,
//               repeat: Infinity,
//               ease: "easeInOut",
//               delay: 1,
//             }}
//           />
//         </motion.div>

//         <div className="absolute left-16 top-12 pl-8 z-20 max-w-[600px]">
//           <h2 className="text-[48.2px] font-bold font-bricolage">
//             <span className="text-[#def0ff]">
//               What people are
//               <br />
//               saying{" "}
//             </span>
//             <span className="text-[#ffae00]">about us</span>
//           </h2>
//         </div>

//         {testimonials.slice(0, 6).map((testimonial, index) => (
//           <TestimonialCard
//             key={testimonial.id}
//             className={`absolute rounded-xl border-none ${
//               index === 0
//                 ? "w-[292px] h-[229px] top-[180px] left-[606px] bg-[#313434] z-10"
//                 : index === 1
//                 ? "w-[292px] h-[187px] top-[450px] left-[735px] bg-[#313435] z-10"
//                 : index === 2
//                 ? "w-[292px] h-[219px] top-[430px] left-[380px] bg-[#313435] z-10"
//                 : index === 3
//                 ? "w-[323px] h-[129px] top-[100px] left-[1037px] bg-[#313435] z-10"
//                 : index === 4
//                 ? "w-[328px] h-[129px] top-[220px] left-[922px] bg-[#313435] z-10"
//                 : "w-[292px] h-[187px] top-[450px] left-[1074px] bg-[#313435] z-10"
//             }`}
//             delay={0.2 + index * 0.1}
//             scrollY={index % 2 === 0 ? y1 : y2}
//           >
//             <CardContent className="p-0 h-full relative">
//               {index === 0 && (
//                 <>
//                   <motion.div
//                     initial={{ scale: 0, y: -20 }}
//                     whileInView={{ scale: 1, y: 0 }}
//                     transition={{ duration: 0.6, delay: 0.4 }}
//                     viewport={{ once: true }}
//                   >
//                     <Avatar className="absolute w-[66px] h-[66px] -top-[37px] left-[113px]">
//                       <AvatarImage src={testimonial.avatarSrc} alt="User" />
//                       <AvatarFallback>SB</AvatarFallback>
//                     </Avatar>
//                   </motion.div>
//                   <motion.div
//                     className="flex w-[116px] items-center top-[35px] left-[87px] flex-col absolute"
//                     initial={{ opacity: 0, y: 20 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.6, delay: 0.5 }}
//                     viewport={{ once: true }}
//                   >
//                     <div className="h-[23px] text-base text-center leading-[normal] relative self-stretch mt-[-1.00px] font-bricolage font-bold text-[#def0ff] tracking-[0]">
//                       {testimonial.name}
//                     </div>
//                     <div className="relative self-stretch h-[18px] font-bricolage font-medium text-[#ffae00] text-xs text-center tracking-[0] leading-[normal]">
//                       {testimonial.company}
//                     </div>
//                   </motion.div>
//                   <motion.div
//                     className="absolute w-[244px] top-[90px] left-[26px] [font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-[#f1f1f1] text-xs tracking-[0] leading-[normal]"
//                     initial={{ opacity: 0, y: 20 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.6, delay: 0.6 }}
//                     viewport={{ once: true }}
//                   >
//                     {testimonial.text}
//                   </motion.div>
//                 </>
//               )}
//               {index === 1 && (
//                 <>
//                   <motion.div
//                     className="absolute w-[244px] top-[21px] left-[15px] [font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-[#f1f1f1] text-xs tracking-[0] leading-[normal]"
//                     initial={{ opacity: 0, x: -20 }}
//                     whileInView={{ opacity: 1, x: 0 }}
//                     transition={{ duration: 0.6, delay: 0.6 }}
//                     viewport={{ once: true }}
//                   >
//                     {testimonial.text}
//                   </motion.div>
//                   <motion.div
//                     className="flex flex-col w-[116px] items-start absolute top-[115px] left-[15px]"
//                     initial={{ opacity: 0, y: 20 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.6, delay: 0.7 }}
//                     viewport={{ once: true }}
//                   >
//                     <div className="flex flex-col items-center relative self-stretch w-full flex-[0_0_auto]">
//                       <div className="relative self-stretch h-[23px] mt-[-1.00px] font-bricolage font-bold text-[#def0ff] text-base tracking-[0] leading-[normal]">
//                         {testimonial.name}
//                       </div>
//                       <div className="relative self-stretch h-[18px] font-bricolage font-medium text-[#ffae00] text-xs tracking-[0] leading-[normal]">
//                         {testimonial.company}
//                       </div>
//                     </div>
//                   </motion.div>
//                   <motion.div
//                     initial={{ scale: 0, rotate: -180 }}
//                     whileInView={{ scale: 1, rotate: 0 }}
//                     transition={{ duration: 0.6, delay: 0.8 }}
//                     viewport={{ once: true }}
//                   >
//                     <Avatar className="absolute w-[50px] h-[50px] top-[115px] left-[209px]">
//                       <AvatarImage src={testimonial.avatarSrc} alt="User" />
//                       <AvatarFallback>SB</AvatarFallback>
//                     </Avatar>
//                   </motion.div>
//                 </>
//               )}
//               {index === 2 && (
//                 <>
//                   <motion.div
//                     className="absolute w-[244px] top-[21px] left-[15px] [font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-[#f1f1f1] text-xs tracking-[0] leading-[normal]"
//                     initial={{ opacity: 0, y: 15 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.6, delay: 0.9 }}
//                     viewport={{ once: true }}
//                   >
//                     {testimonial.text}
//                   </motion.div>
//                   <motion.div
//                     className="flex flex-col w-[116px] items-start absolute top-[115px] left-[15px]"
//                     initial={{ opacity: 0, y: 20 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.6, delay: 1 }}
//                     viewport={{ once: true }}
//                   >
//                     <div className="flex flex-col items-center relative self-stretch w-full flex-[0_0_auto]">
//                       <div className="relative self-stretch h-[23px] mt-[-1.00px] font-bricolage font-bold text-[#def0ff] text-base tracking-[0] leading-[normal]">
//                         {testimonial.name}
//                       </div>
//                       <div className="relative self-stretch h-[18px] font-bricolage font-medium text-[#ffae00] text-xs tracking-[0] leading-[normal]">
//                         {testimonial.company}
//                       </div>
//                     </div>
//                   </motion.div>
//                   <motion.div
//                     initial={{ scale: 0, rotate: 90 }}
//                     whileInView={{ scale: 1, rotate: 0 }}
//                     transition={{ duration: 0.6, delay: 1.1 }}
//                     viewport={{ once: true }}
//                   >
//                     <Avatar className="absolute w-[50px] h-[50px] top-[115px] left-[209px]">
//                       <AvatarImage src={testimonial.avatarSrc} alt="User" />
//                       <AvatarFallback>SB</AvatarFallback>
//                     </Avatar>
//                   </motion.div>
//                 </>
//               )}
//               {index === 3 && (
//                 <>
//                   {/* Quote Icon (absolute, decorative) */}
//                   <motion.div
//                     className="absolute w-7 h-7 -top-2.5 left-4"
//                     initial={{ opacity: 0, rotate: -90 }}
//                     whileInView={{ opacity: 1, rotate: 0 }}
//                     transition={{ duration: 0.5, delay: 0.7 }}
//                     viewport={{ once: true }}
//                   >
//                     <Image
//                       className="w-6 h-[21px]"
//                       alt="Quote"
//                       src={testimonial.quoteSrc}
//                       width={24}
//                       height={21}
//                     />
//                   </motion.div>

//                   {/* Fixed height container (129px), with horizontal layout */}
//                   <motion.div
//                     className="absolute top-0 left-[53px] w-[322px] h-[129px] flex items-start justify-between bg-[#313435] rounded-xl p-3 overflow-hidden"
//                     initial={{ opacity: 0, x: 10 }}
//                     whileInView={{ opacity: 1, x: 0 }}
//                     transition={{ duration: 0.6, delay: 0.6 }}
//                     viewport={{ once: true }}
//                   >
//                     {/* Left: Text and Info */}
//                     <div className="flex flex-col justify-between w-[170px] h-full">
//                       {/* Testimonial Text */}
//                       <motion.p
//                         className="text-xs text-[#f1f1f1] font-jakarta leading-[14.4px] overflow-hidden text-ellipsis line-clamp-4"
//                         initial={{ opacity: 0, x: -15 }}
//                         whileInView={{ opacity: 1, x: 0 }}
//                         transition={{ duration: 0.6, delay: 0.7 }}
//                         viewport={{ once: true }}
//                       >
//                         {testimonial.text}
//                       </motion.p>

//                       {/* Name and Company */}
//                       <motion.div
//                         className="mt-1"
//                         initial={{ opacity: 0, y: 10 }}
//                         whileInView={{ opacity: 1, y: 0 }}
//                         transition={{ duration: 0.6, delay: 0.8 }}
//                         viewport={{ once: true }}
//                       >
//                         <div className="text-sm font-bricolage font-bold text-[#def0ff] leading-[14px] truncate">
//                           {testimonial.name}
//                         </div>
//                         <div className="text-xs font-bricolage font-medium text-[#ffae00] leading-[normal]">
//                           {testimonial.company}
//                         </div>
//                       </motion.div>
//                     </div>

//                     {/* Right: Avatar */}
//                     <motion.div
//                       initial={{ scale: 0, x: 20 }}
//                       whileInView={{ scale: 1, x: 0 }}
//                       transition={{ duration: 0.6, delay: 0.9 }}
//                       viewport={{ once: true }}
//                     >
//                       <Avatar className="w-[96px] h-[96px] mt-0.5">
//                         <AvatarImage src={testimonial.avatarSrc} alt="User" />
//                         <AvatarFallback>SB</AvatarFallback>
//                       </Avatar>
//                     </motion.div>
//                   </motion.div>
//                 </>
//               )}
//               {index === 4 && (
//                 <>
//                   <motion.div
//                     initial={{ scale: 0, x: -20 }}
//                     whileInView={{ scale: 1, x: 0 }}
//                     transition={{ duration: 0.6, delay: 0.8 }}
//                     viewport={{ once: true }}
//                   >
//                     <div className="flex bg-[#313435] rounded-xl p-4 gap-4 w-full max-w-md min-h-[100px]">
//                       <div className="flex-shrink-0">
//                         <Avatar className="w-[104px] h-[104px]">
//                           <AvatarImage src={testimonial.avatarSrc} alt="User" />
//                           <AvatarFallback>SB</AvatarFallback>
//                         </Avatar>
//                       </div>
//                       <div className="flex flex-col justify-between">
//                         <motion.p
//                           className="text-xs text-[#f1f1f1] font-[Plus_Jakarta_Sans] leading-[1.4]"
//                           initial={{ opacity: 0, x: 20 }}
//                           whileInView={{ opacity: 1, x: 0 }}
//                           transition={{ duration: 0.6, delay: 0.9 }}
//                           viewport={{ once: true }}
//                         >
//                           {testimonial.text}
//                         </motion.p>
//                         <motion.div
//                           className="mt-4"
//                           initial={{ opacity: 0, y: 15 }}
//                           whileInView={{ opacity: 1, y: 0 }}
//                           transition={{ duration: 0.6, delay: 1 }}
//                           viewport={{ once: true }}
//                         >
//                           <div className="text-sm font-bricolage font-bold text-[#def0ff] leading-[14px]">
//                             {testimonial.name}
//                           </div>
//                           <div className="text-xs font-bricolage font-medium text-[#ffae00]">
//                             {testimonial.company}
//                           </div>
//                         </motion.div>
//                       </div>
//                     </div>
//                   </motion.div>
//                 </>
//               )}
//               {index === 5 && (
//                 <>
//                   <motion.div
//                     className="absolute w-[244px] top-[21px] left-[15px] [font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-[#f1f1f1] text-xs tracking-[0] leading-[normal]"
//                     initial={{ opacity: 0, y: 15 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.6, delay: 0.9 }}
//                     viewport={{ once: true }}
//                   >
//                     {testimonial.text}
//                   </motion.div>
//                   <motion.div
//                     className="flex flex-col w-[116px] items-start absolute top-[115px] left-[15px]"
//                     initial={{ opacity: 0, y: 20 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.6, delay: 1 }}
//                     viewport={{ once: true }}
//                   >
//                     <div className="flex flex-col items-center relative self-stretch w-full flex-[0_0_auto]">
//                       <div className="relative self-stretch h-[23px] mt-[-1.00px] font-bricolage font-bold text-[#def0ff] text-base tracking-[0] leading-[normal]">
//                         {testimonial.name}
//                       </div>
//                       <div className="relative self-stretch h-[18px] font-bricolage font-medium text-[#ffae00] text-xs tracking-[0] leading-[normal]">
//                         {testimonial.company}
//                       </div>
//                     </div>
//                   </motion.div>
//                   <motion.div
//                     initial={{ scale: 0, rotate: 90 }}
//                     whileInView={{ scale: 1, rotate: 0 }}
//                     transition={{ duration: 0.6, delay: 1.1 }}
//                     viewport={{ once: true }}
//                   >
//                     <Avatar className="absolute w-[50px] h-[50px] top-[115px] left-[209px]">
//                       <AvatarImage src={testimonial.avatarSrc} alt="User" />
//                       <AvatarFallback>SB</AvatarFallback>
//                     </Avatar>
//                   </motion.div>
//                 </>
//               )}
//             </CardContent>
//           </TestimonialCard>
//         ))}

//         <motion.div
//           className="absolute top-[150px] left-[524px] w-[60px] h-[60px]"
//           whileHover={{ scale: 1.1, rotate: -5 }}
//           whileTap={{ scale: 0.95 }}
//           style={{ y: y1 }}
//         >
//           <motion.div
//             animate={{ rotate: [0, 5, -5, 0] }}
//             transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
//           >
//             <Image
//               className="absolute w-[52px] h-[45px] top-2 left-1"
//               alt="Previous"
//               src="/group-7.png"
//               width={52}
//               height={45}
//             />
//           </motion.div>
//         </motion.div>
//         <motion.div
//           className="absolute top-[400px] left-[1382px] rotate-180 w-[60px] h-[60px]"
//           whileHover={{ scale: 1.1, rotate: 5 }}
//           whileTap={{ scale: 0.95 }}
//           style={{ y: y2 }}
//         >
//           <motion.div
//             animate={{ rotate: [180, 175, 185, 180] }}
//             transition={{
//               duration: 4,
//               repeat: Infinity,
//               ease: "easeInOut",
//               delay: 2,
//             }}
//           >
//             <Image
//               className="absolute w-[52px] h-[45px] top-2 left-1 -rotate-180"
//               alt="Next"
//               src="/group-8.png"
//               width={52}
//               height={45}
//             />
//           </motion.div>
//         </motion.div>
//       </div>

//       {/* Mobile & Tablet Layout (below 1024px) */}
//       <div className="lg:hidden px-4 py-8 h-full flex flex-col">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl md:text-4xl font-bold font-bricolage">
//             <span className="text-[#def0ff] block">
//               What people are saying{" "}
//             </span>
//             <span className="text-[#ffae00]">about us</span>
//           </h2>
//         </div>

//         <div className="relative w-full flex-1 overflow-hidden">
//           {testimonials.map((testimonial, index) => (
//             <MobileTestimonialCard
//               key={testimonial.id}
//               isActive={index === currentIndex}
//             >
//               <div className="flex flex-col items-center p-6 bg-[#313435] rounded-xl w-[320px] mx-auto">
//                 {testimonial.avatarSrc && !testimonial.extraAvatar && (
//                   <Avatar className="w-16 h-16 mb-4">
//                     <AvatarImage src={testimonial.avatarSrc} alt="User" />
//                     <AvatarFallback>SB</AvatarFallback>
//                   </Avatar>
//                 )}
//                 {testimonial.extraAvatar && (
//                   <div className="flex items-center gap-2 mb-4">
//                     <Avatar className="w-12 h-12">
//                       <AvatarImage src={testimonial.avatarSrc} alt="User" />
//                       <AvatarFallback>SB</AvatarFallback>
//                     </Avatar>
//                     <div className="w-16 h-16 bg-[url(/ellipse-200.svg)] bg-cover bg-center rounded-full" />
//                     <Avatar className="w-12 h-12">
//                       <AvatarImage src={testimonial.extraAvatar} alt="User" />
//                       <AvatarFallback>SB</AvatarFallback>
//                     </Avatar>
//                   </div>
//                 )}
//                 {testimonial.quoteSrc && (
//                   <div className="w-6 h-6 mb-3">
//                     <Image
//                       className="w-full h-full"
//                       alt="Quote"
//                       src={testimonial.quoteSrc}
//                       width={24}
//                       height={21}
//                     />
//                   </div>
//                 )}
//                 <p className="text-xs text-[#f1f1f1] text-center leading-relaxed [font-family:'Plus_Jakarta_Sans',Helvetica] mb-4">
//                   {testimonial.text}
//                 </p>
//                 <div className="text-center">
//                   <div className="text-base font-bold text-[#def0ff] font-bricolage mb-1">
//                     {testimonial.name}
//                   </div>
//                   <div className="text-xs font-medium text-[#ffae00] font-bricolage mb-2">
//                     {testimonial.company}
//                   </div>
//                   {testimonial.ratingSrc && (
//                     <Image
//                       className="mx-auto"
//                       alt="Rating"
//                       src={testimonial.ratingSrc}
//                       width={102}
//                       height={16}
//                     />
//                   )}
//                 </div>
//               </div>
//             </MobileTestimonialCard>
//           ))}
        
//         </div>
//   <div className="flex justify-center gap-4 mt-20 items-center absolute bottom-4 left-0 right-0">
//             <motion.button
//               onClick={handlePrev}
//               className="w-12 h-12 rounded-full bg-[#ffae00] text-[#1d1d20] flex items-center justify-center transition-colors duration-200 shadow-md"
//               whileHover={{ scale: 1.1 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <svg
//                 className="w-6 h-6"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M15 19l-7-7 7-7"
//                 />
//               </svg>
//             </motion.button>
//             <div className="flex gap-2">
//               {Array.from({ length: Math.min(4, testimonials.length) }).map(
//                 (_, i) => (
//                   <span
//                     key={i}
//                     className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                       i === currentIndex % 4
//                         ? "bg-[#ffae00] scale-125"
//                         : "bg-[#FFFFFFE699]"
//                     }`}
//                   />
//                 )
//               )}
//             </div>
//             <motion.button
//               onClick={handleNext}
//               className="w-12 h-12 rounded-full bg-[#ffae00] text-[#1d1d20] flex items-center justify-center transition-colors duration-200 shadow-md"
//               whileHover={{ scale: 1.1 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <svg
//                 className="w-6 h-6"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M9 5l7 7-7 7"
//                 />
//               </svg>
//             </motion.button>
//           </div>
//         <div className="absolute inset-0 pointer-events-none overflow-hidden">
//           <motion.div
//             className="absolute w-2 h-2 top-10 right-8 bg-white rounded-full opacity-70"
//             animate={{ scale: [1, 1.2, 1], opacity: [0.7, 1, 0.7] }}
//             transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
//           />
//           <motion.div
//             className="absolute w-2 h-2 top-32 left-8 bg-white rounded-full opacity-70"
//             animate={{ scale: [1, 1.2, 1], opacity: [0.7, 1, 0.7] }}
//             transition={{
//               duration: 2,
//               repeat: Infinity,
//               ease: "easeInOut",
//               delay: 0.5,
//             }}
//           />
//           <motion.div
//             className="absolute w-2 h-2 bottom-20 right-12 bg-white rounded-full opacity-70"
//             animate={{ scale: [1, 1.2, 1], opacity: [0.7, 1, 0.7] }}
//             transition={{
//               duration: 2,
//               repeat: Infinity,
//               ease: "easeInOut",
//               delay: 1,
//             }}
//           />
//         </div>
//       </div>
//     </motion.section>
//   );
// };

// export default TestimonialsSection;


"use client";

import { useState, useEffect, useRef, useCallback } from 'react';
import { motion } from 'framer-motion';
import Image from "next/image";

const PERSPECTIVE = 1200;
const DRAG_THRESHOLD = 50;

const SAMPLE_IMAGES = [
  {
    title: "Ideas in Motion",
    description: "A deep discussion filled with innovative thoughts and shared learning.",
    imageUrl: "/GroupDiscuss1.JPG",
  },
  {
    title: "Peaceful Horizons",
    description: "Where calmness meets curiosity and ideas flow like the wind.",
    imageUrl: "/House&Mountain.JPG",
  },
  {
    title: "Gift of Growth",
    description: "A moment that symbolizes gratitude, learning, and shared success.",
    imageUrl: "/gift.JPG",
  },
  {
    title: "Path of Discovery",
    description: "Walking into new ideas, adventures, and peaceful reflections.",
    imageUrl: "/House.JPG",
  },
  {
    title: "Mountains of Mindset",
    description: "Scaling thoughts as high as the mountains — a true journey within.",
    imageUrl: "/Mountains.JPG",
  },
  {
    title: "Voices of Vision",
    description: "Interactive talks where every word carried energy and ambition.",
    imageUrl: "/talk.JPG",
  },
  {
    title: "Together We Build",
    description: "Learning through teamwork — exploring challenges and creativity.",
    imageUrl: "/Groupminidiscuss2.JPG",
  },
  {
    title: "Moments of Calm",
    description: "Finding peace amidst the rhythm of shared experiences.",
    imageUrl: "/Group2.JPG",
  },
  {
    title: "Reflections of Progress",
    description: "Looking back at how far we’ve come — inspired and ready for more.",
    imageUrl: "/groupgifts.JPG",
  },
  {
    title: "Vision Beyond Limits",
    description: "Exploring ideas, nature, and the endless drive to create impact.",
    imageUrl: "/explain.JPG",
  }
];

export default function TripCoverflowCarousel({ 
  images = SAMPLE_IMAGES, 
  autoPlayInterval = 3000 
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const dragStartX = useRef(0);
  const carouselRef = useRef(null);

  const totalImages = images.length;

  const handleNext = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % totalImages);
  }, [totalImages]);

  const handlePrev = useCallback(() => {
    setCurrentIndex((prev) => (prev - 1 + totalImages) % totalImages);
  }, [totalImages]);

  useEffect(() => {
    if (isPaused || autoPlayInterval <= 0) return;

    const interval = setInterval(() => {
      handleNext();
    }, autoPlayInterval);

    return () => clearInterval(interval);
  }, [isPaused, autoPlayInterval, handleNext]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        handlePrev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        handleNext();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleNext, handlePrev]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const getRelativePosition = (index) => {
    let diff = index - currentIndex;
    if (diff > totalImages / 2) diff -= totalImages;
    if (diff < -totalImages / 2) diff += totalImages;
    return diff;
  };

  const getItemStyle = (relativePos) => {
    if (relativePos === 0) {
      return { scale: 1, x: 0, rotateY: 0, opacity: 1, zIndex: 30 };
    }
    
    if (Math.abs(relativePos) === 1) {
      return { scale: 0.75, x: relativePos * 280, rotateY: relativePos * 28, opacity: 0.8, zIndex: 20 };
    }
    
    if (Math.abs(relativePos) === 2) {
      return { scale: 0.6, x: relativePos * 450, rotateY: relativePos * 38, opacity: 0.4, zIndex: 10 };
    }
    
    return { scale: 0.5, x: relativePos * 600, rotateY: relativePos * 45, opacity: 0, zIndex: 0 };
  };

  const handleDragStart = (event, info) => {
    dragStartX.current = info.point.x;
    setIsPaused(true);
  };

  const handleDragEnd = (event, info) => {
    const dragDistance = info.point.x - dragStartX.current;
    
    if (Math.abs(dragDistance) > DRAG_THRESHOLD) {
      dragDistance > 0 ? handlePrev() : handleNext();
    }
    
    setTimeout(() => setIsPaused(false), 100);
  };

  return (
    <div 
      className="w-full min-h-screen py-12 px-4 sm:px-6 lg:px-8 overflow-hidden "
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-5xl font-bold text-[#FFAE00] mb-4">
            Where Adventure Met Learning and Memories Were Made
          </h1>
          <p className="text-base sm:text-xl text-gray-400 mt-2">
            From sunrise hikes to late-night reflections — every adventure taught us something new.
          </p>
        </div>

        <div 
          ref={carouselRef}
          className="relative h-[350px] sm:h-[450px] md:h-[600px] mb-8"
          style={{ perspective: `${PERSPECTIVE}px` }}
        >
          <motion.div
            className="absolute inset-0 flex items-center justify-center cursor-grab active:cursor-grabbing"
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={0.1}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
          >
            {images.map((image, index) => {
              const relativePos = getRelativePosition(index);
              const style = getItemStyle(relativePos);
              const isVisible = Math.abs(relativePos) <= 2;

              return (
                <motion.div
                  key={index}
                  layout
                  className="absolute w-[90%] sm:w-[75%] md:w-[60%] aspect-video will-change-transform"
                  animate={style}
                  transition={{ type: "spring", stiffness: 80, damping: 18, mass: 0.6 }}
                  style={{ transformStyle: "preserve-3d", pointerEvents: relativePos === 0 ? "auto" : "none" }}
                >
                  {isVisible && (
                    <div className="relative w-full h-[300px] sm:h-[400px] md:h-[550px] rounded-2xl overflow-hidden shadow-2xl border border-white/5 bg-[#1a1a1a]">
                      <Image
                        src={image.imageUrl}
                        alt={image.title}
                        fill
                        priority={index === currentIndex} 
                        className="object-cover"
                        sizes="(max-width: 768px) 100vw, 60vw"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
                      
                      <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-10 text-white">
                        <h3 className="text-xl sm:text-3xl font-bold mb-2 text-[#FFAE00]">
                          {image.title}
                        </h3>
                        <p className="text-sm sm:text-lg text-gray-300 line-clamp-2">
                          {image.description}
                        </p>
                      </div>
                    </div>
                  )}
                </motion.div>
              );
            })}
          </motion.div>

          <button
            onClick={handlePrev}
            className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 z-40 bg-[#FFAE00] text-black p-3 rounded-full transition-all hover:scale-110 shadow-xl"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <button
            onClick={handleNext}
            className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 z-40 bg-[#FFAE00] text-black p-3 rounded-full transition-all hover:scale-110 shadow-xl"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>   
        </div>

        <div className="flex justify-center items-center gap-3">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`h-2.5 rounded-full transition-all duration-300 ${
                index === currentIndex ? 'w-10 bg-[#FFAE00]' : 'w-2.5 bg-gray-600 hover:bg-gray-400'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}